<template>
    <div>
        <b-container>
            <b-form-group>
                <b-row>

                    <b-col>
                        <app-box titulo="Movimentação Mínima">{{ Intl.NumberFormat('pt-BR').format(movimentacao.quantidade) }}</app-box>
                    </b-col>

                    <b-col>
                        <app-box titulo="Qtde Total">{{ Intl.NumberFormat('pt-BR').format(movimentacao.quantidadeTotal) }}</app-box>
                    </b-col>

                    <b-col>
                        <app-box titulo="Saldo">{{ Intl.NumberFormat('pt-BR').format(movimentacao.saldo) }}</app-box>
                    </b-col>

                    <b-col>
                        <b-button variant="primary" 
                            :disabled="btnComprometerSaldoDesabilitado"
                            @click="comprometerSaldo(movimentacao.movimentacaoMinimaId)"
                        >
                            Comprometer Saldo
                        </b-button>
                    </b-col>
                </b-row>
            </b-form-group>
        </b-container>

        <app-tabela 
            idTabela="tblParcelasMovimentacoes" 
            :itens="movimentacao.parcelas" 
            :campos="campos"
            :bordered="false" 
            :small="false" 
            :mostrarFiltro="false">

            <template slot="tarifa" slot-scope="data">
                {{ data.tarifa | currency }}
            </template>

            <template slot="variavel" slot-scope="data">
                {{ data.variavel | currency }}
            </template>

            <template slot="mesAnoParcela" slot-scope="data">
                {{ $moment(data.mesAnoParcela).format('MM/YYYY') }}
            </template>

            <template slot="status" slot-scope="data">
                <h5>
                    <b-badge size="large" :variant="corStatus(data.status)">{{ descreverStatus(data.status) }}</b-badge>
                </h5>
            </template>
        </app-tabela>
    </div>
</template>


<script>

import MovimentacoesMinimasServicos from './MovimentacoesMinimasServicos'

export default {
    props: {
        movimentacao: {
            type: Object,
            default: {}
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'mesAnoParcela',
                    label: 'Competência',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'quantidade',
                    label: 'Qtde',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'tarifa',
                    label: 'Tarifa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'variavel',
                    label: 'Variável',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    filterable: true
                }
            ],

            statusParcelas: [
                { id: 0, descricao: 'Pendente' },
                { id: 1, descricao: 'Enviado' }
            ],

            btnComprometerSaldoDesabilitado: true
        }
    },

    methods: {
        descreverStatus(statusId) {
            var status = this.statusParcelas.find(item => item.id === statusId);
            return status.descricao
        },

        corStatus(statusId) {
            return statusId == 0 ? 'light' : 'success';
        },

        comprometerSaldo(movimentacaoMinimaId) {

            this.$swal({
                title: 'Movimentação Mínima',
                html: 'Deseja realmente requisitar o comprometimento do saldo da movimentação?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.requisitarComprometimentoSaldoMovimentacao(movimentacaoMinimaId);
                }
            })
        },

        requisitarComprometimentoSaldoMovimentacao(movimentacaoMinimaId) {
            this.btnComprometerSaldoDesabilitado = true
            this.$store.dispatch('addRequest')

            MovimentacoesMinimasServicos.requisitarComprometimentoSaldoMovimentacao(movimentacaoMinimaId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Comprometimento de saldo requisitado',
                                'SUCCESS',
                                this.$toastConfig.success
                            )
                        } else {
                            this.$toast.error(
                                'Erro ao requisitar o comprometimento do saldo da movimentação',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }

                    this.$store.dispatch('removeRequest')
                    this.btnComprometerSaldoDesabilitado = false
                });
        }
    },

    mounted() {
    
        if (this.movimentacao.parcelas || this.movimentacao.parcelas.length > 0){

            const parcelasOrdenas = this.movimentacao.parcelas.sort((a, b) => 
                new Date(a.mesAnoParcela) - new Date(b.mesAnoParcela)
            );

            const ultimaParcela = parcelasOrdenas[parcelasOrdenas.length - 1];
            const dataUltimaParcela = new Date(ultimaParcela.mesAnoParcela)
            const dataAtual = new Date();

            this.btnComprometerSaldoDesabilitado = !(dataUltimaParcela.getFullYear() === dataAtual.getFullYear() && 
                                                    dataUltimaParcela.getMonth() === dataAtual.getMonth() &&
                                                    this.movimentacao.saldo > 0);
        } 
    }
}

</script>